import HTTP from '@rocketfid/api'

const state = {
  items: []
}

// getters
const getters = {
  bubbles: (state) => {
    return state.items
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  }
}

// actions
const actions = {

  loadBubble ({ commit, dispatch, rootGetters }, { idBubble }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .bubble.get(idBubble)
      .then((bubble) => {
        dispatch('bubbles/resetBubbles', null, { root: true })
        commit('ADD_BUBBLE_ITEM', { item: bubble })
        return bubble
      })
  },

  loadBubbles ({ commit, dispatch, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .bubble.getAll()
      .then((bubbles) => {
        dispatch('bubbles/resetBubbles', null, { root: true })
        commit('ADD_BUBBLE_ITEMS', { items: bubbles })
        return bubbles
      })
  },

  resetBubbles ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_BUBBLE_ITEMS')
      resolve()
    })
  },

  addBubble ({ commit, rootGetters }, { bubble }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .bubble.create(bubble)
      .then((bubble) => {
        commit('ADD_BUBBLE_ITEM', { item: bubble })
        return bubble
      })
  },

  addBubbleFromIntersection ({ commit, rootGetters }, { bubble }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .bubble.createFromIntersection(bubble)
      .then((bubble) => {
        commit('ADD_BUBBLE_ITEM', { item: bubble })
        return bubble
      })
  },

  updateBubble ({ commit, rootGetters }, { bubble }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .bubble.update(bubble)
      .then((bubble) => {
        commit('UPDATE_BUBBLE_ITEM', { item: bubble })
        return bubble
      })
  },

  refreshBubble ({ commit, rootGetters }, { bubble }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .bubble.refresh(bubble)
      .then((bubble) => {
        commit('UPDATE_BUBBLE_ITEM', { item: bubble })
        return bubble
      })
  },

  removeBubble ({ commit, rootGetters }, { bubble }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .bubble.delete(bubble)
      .then((bubble) => {
        commit('REMOVE_BUBBLE_ITEM', { item: bubble })
        return bubble
      })
  }
}

// mutations
const mutations = {
  ADD_BUBBLE_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },

  RESET_BUBBLE_ITEMS: (state) => {
    state.items = []
  },

  ADD_BUBBLE_ITEM: (state, { item }) => {
    state.items.push(item)
  },

  UPDATE_BUBBLE_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
      }
    }
  },
  REMOVE_BUBBLE_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bubbles.js